import { JsonFragment } from "../abis.model";

export const DAOExpanderFactoryABI: JsonFragment[] = [
  {
    inputs: [
      {
        internalType: "address",
        name: "deployer",
        type: "address",
      },
      {
        internalType: "address",
        name: "autIDAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "daoTypesAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "daoType",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "daoAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "market",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "metadata",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "commitment",
        type: "uint256",
      },
    ],
    name: "deployDAOExpander",
    outputs: [
      {
        internalType: "address",
        name: "_daoExpanderAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];
